<template>
  <div class="shopping">
    <Row class="top-title"
         type="flex"
         justify="space-between"
         align="bottom">
      <i-col span="8"
             class="title-left">
        <span>课程商城</span>
        <router-link to="/mymenu">我的首页</router-link>
      </i-col>
    </Row>
    <ul class="total">
      <li class="item">
        <div class="item-title">
          <img class="vm"
               src="@/assets/shopping/q1.png"
               alt />
          <span class="vm">学习推荐</span>
        </div>
        <Row type="flex"
             justify="start">
          <i-col span="7"
                 class="wrap-item"
                 v-for="(item, index) in choicenessList"
                 :key="index">
            <img @click="toGoodsDetail(item.id)"
                 :src="item.activityCoverFileUrl"
                 @mouseover="isShowIndex = index" />
            <div class="introduce"
             @click="toGoodsDetail(item.id)"
                 v-show="isShowIndex === index"
                 @mouseleave="isShowIndex = ''">
              <p @click="toGoodsDetail(item.id)">{{ item.activityName }}</p>
              <Row type="flex"
                   justify="space-between">
                <i-col span="10">￥{{ item.price / 100 }}元</i-col>
                <i-col span="7"
                       class="good">高级</i-col>
              </Row>
              <span @click="toGoodsDetail(item.id)">{{ item.activityDesc }}</span>
              <!-- <Poptip width="240" height="280" :title="'微信扫一扫购买课程'">
                <p>{{ item.activityName }}</p>
                <Row type="flex" justify="space-between">
                  <i-col span="10">￥{{ item.price / 100 }}元</i-col>
                  <i-col span="7" class="good">高级</i-col>
                </Row>
                <span>{{ item.activityDesc }}</span>
                <div class="bind-wechat" slot="content">
                  <qrcode-vue :value="getBuyLink(item.id)" :size="200" level="H"></qrcode-vue>
                </div>
              </Poptip>-->
            </div>
          </i-col>
        </Row>
      </li>
      <li class="item">
        <div class="item-title">
          <img class="vm"
               style="margin-top: -10px"
               src="@/assets/shopping/q2.png"
               alt />
          <span class="vm">入门点播课程</span>
        </div>
        <Row type="flex"
             justify="start">
          <i-col span="5"
                 class="wrap-item wrap-item2"
                 v-for="(item, index) in activityList1"
                 :key="index">
            <img @click="toGoodsDetail(item.id)"
                 :src="item.activityCoverFileUrl"
                 @mouseover="isShowIndex1 = index" />
            <div class="introduce"
             @click="toGoodsDetail(item.id)"
                 v-show="isShowIndex1 === index"
                 @mouseleave="isShowIndex1 = ''">
              <p @click="toGoodsDetail(item.id)">{{ item.activityName }}</p>
              <span @click="toGoodsDetail(item.id)">{{ item.activityDesc }}</span>
              <!-- <Poptip width="240" height="280" :title="'微信扫一扫购买课程'">
                <p>{{ item.activityName }}</p>
                <span>{{ item.activityDesc }}</span>
                <div class="bind-wechat" slot="content">
                  <qrcode-vue :value="getBuyLink(item.id)" :size="200" level="H"></qrcode-vue>
                </div>
              </Poptip>-->
            </div>
          </i-col>
        </Row>
      </li>
      <li class="item">
        <div class="item-title">
          <img class="vm"
               style="margin-top: 8px"
               src="@/assets/shopping/q3.png"
               alt />
          <span class="vm">进阶点播课程</span>
        </div>
        <Row type="flex"
             justify="start">
          <i-col span="5"
                 class="wrap-item wrap-item2"
                 v-for="(item, index) in activityList2"
                 :key="index">
            <img @click="toGoodsDetail(item.id)"
                 :src="item.activityCoverFileUrl"
                 @mouseover="isShowIndex2 = index" />
            <div class="introduce"
             @click="toGoodsDetail(item.id)"
                 v-show="isShowIndex2 === index"
                 @mouseleave="isShowIndex2 = ''">
              <p @click="toGoodsDetail(item.id)">{{ item.activityName }}</p>
              <span @click="toGoodsDetail(item.id)">{{ item.activityDesc }}</span>
            </div>
            <!-- <Poptip width="240" height="280" :title="'微信扫一扫购买课程'">
              <div
                class="introduce"
                v-show="isShowIndex2 === index"
                @mouseleave="isShowIndex2 = ''"
              >
                <p>{{ item.activityName }}</p>
                <span>{{ item.activityDesc }}</span>
              </div>
              <div class="bind-wechat" slot="content">
                <qrcode-vue :value="getBuyLink(item.id)" :size="200" level="H"></qrcode-vue>
              </div>
            </Poptip>-->
          </i-col>
        </Row>
      </li>
    </ul>
  </div>
</template>
<script>
import { logout } from "@/api";
import { removeToken, getUserInfo, removeUserInfo } from "@/utils/auth";
import { getActivityList, getBuyLink } from "@/api/buy";
// import QrcodeVue from "qrcode.vue";
export default {
  // components: {
  //   QrcodeVue,
  // },
  data () {
    return {
      isShowIndex: "",
      isShowIndex1: "",
      isShowIndex2: "",
      activityList1: [],
      activityList2: [],
      choicenessList: [],
    };
  },
  created () {
    this.getActivityList();
  },
  methods: {
    logout () {
      logout().then((res) => {
        console.log(res);
        if (res.code === 200) {
          removeToken();
          removeUserInfo();
          this.$Message.success(res.message);
          setTimeout(() => {
            this.$router.replace("/home");
          }, 1000);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getActivityList () {
      //推荐
      getActivityList(null, null, null, 2, 99).then((res) => {
        this.choicenessList = res.result;
      });
      //入门
      getActivityList(0, null, null, null, 99).then((res) => {
        this.activityList1 = res.result;
      });
      //进阶
      getActivityList(1, null, null , null, 99).then((res) => {
        this.activityList2 = res.result;
      });
    },
    // getBuyLink(id) {
    //   return getBuyLink(id);
    // },
    toGoodsDetail (actId) {
      this.$router.push({
        path: `/goodsDetail?actId=${actId}`
      });
    }
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.shopping {
  width: 1400px;
  margin: 0 auto;
  .top-title {
     width: 1360px;
    margin: 40px auto 80px;
    .title-left {
      color: #fff;
      span {
        font-weight: 700;
        margin-right: 50px;
        font-size: 30px;
      }
      a {
        font-weight: 700;
        font-size: 20px;
        background: rgb(57, 165, 239);
        display: inline-block;
        border-radius: 30px;
        line-height: 30px;
        padding: 5px 36px;
      }
    }
    .title-right {
      font-size: 20px;
      color: #192648;
      border-radius: 30px;
      background: #fff;
      line-height: 40px;
      padding: 0px 36px;
      height: 40px;
      cursor: pointer;
      &:hover{
        background: #f5c54a;
        color: #fff;
      }
    }
  }
  .total {
    text-align: left;
    .item {
      margin-bottom: 100px;

      &:last-child {
        margin-bottom: 0;
      }
      padding-bottom: 60px;
      .item-title {
        margin-bottom: 40px;
        img {
          width: 45px;
        }
        span {
          font-weight: 700;
          font-size: 18px;
          color: #f4eeee;
        }
      }
      .wrap-item {
        position: relative;
        margin-left: 20px;
        img {
          border-radius: 5px;
          width: 343px;
          height: 231px;
        }
        .introduce {
          border-radius: 5px;
          color: #fff;
          position: absolute;
          top: 0;
          left: 0;
          width: 343px;
          height: 226px;
          background: rgba(0, 0, 0, 0.4);
          padding: 20px;
          p {
            font-size: 16px;
            font-weight: 700;
            padding: 10px 0;
          }
          .good {
            text-align: center;
            background: #39a5ef;
            font-size: 12px;
            padding: 0 10px;
            line-height: 20px;
            border-radius: 5px;
            margin-bottom: 15px;
          }
          span {
            font-size: 10px;
          }
        }
        &.wrap-item2 {
          margin-top: 50px;
          margin-left: 20px;
          img,
          .introduce {
            width: 274px;
            height: 174px;
          }
          .good {
            padding: 0 6px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/shopping.vue